<template>
  <v-container grid-list-lg :class="$vuetify.breakpoint.name !== 'xs' ? 'fill-height' : ''">
    <v-layout row wrap align-center v-show="!credentials.otpRequired">
      <v-flex xs12 sm6 offset-sm3>
        <v-stepper flat non-linear v-model="step">
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card>
                <v-form>
                  <v-card-title>
                    <h3>Login</h3>
                  </v-card-title>
                  <v-card-text class="pb-0">
                    <v-text-field
                      autofocus
                      append-icon="fa-user"
                      label="Email"
                      v-model="credentials.email"
                      @keyup.enter="login"
                      box
                      autocomplete="username"
                    ></v-text-field>
                    <v-text-field
                      :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                      box
                      @click:append="showPassword = !showPassword"
                      @keyup.enter="login"
                      label="Password"
                      :type="showPassword ? 'text' : 'password'"
                      v-model="credentials.password"
                      autocomplete="current-password"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-container text-xs-center pa-0 pl-2 pr-2>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-btn
                          v-if="!passwordExpired"
                          primary
                          large
                          block
                          @click="login"
                          :loading="loading"
                          :disabled="loading"
                        >Login</v-btn>

                        <v-btn
                          v-if="passwordExpired"
                          primary
                          large
                          block
                          @click="forgotPassword"
                          :loading="loading"
                          :disabled="loading"
                        >Reset Password</v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn small flat color="primary" @click="setForgotPassword">Forgot Password</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card>
                <v-form>
                  <v-card-title>
                    <h3>Forgot Password</h3>
                  </v-card-title>
                  <v-card-text>
                    <div v-if="message">
                      {{ message }}
                    </div>
                    <v-text-field
                      append-icon="fa-user"
                      autofocus
                      box
                      label="Email"
                      v-model="credentials.email"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      block
                      @click="forgotPassword"
                      :disabled="loading"
                      large
                      :loading="loading"
                      primary
                    >Send Recovery Email</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-card>
                <v-card-title>
                  <h3>Forgot Password</h3>
                </v-card-title>
                <v-card-text>
                  Please check your email to complete your password recovery.
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
      <v-flex xs12 sm3 v-if="domain === 'blueyonder'">
        <a href="http://www.blueyondercorp.com/referrals" target="_blank">
          <v-img src="/static/blueyonder_banner.png"></v-img>
        </a>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import Bus from '@/bus'
import APIMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [APIMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      loading: false,
      step: 1,
      message: '',
      showPassword: false,
      passwordNewToken: '',
      passwordNew: '',
      passwordNewVerify: '',
      passwordExpired: false,
      credentials: {
        email: '',
        password: '',
        otpToken: false,
        otpRequired: false
      },
      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+/.test(v) || 'Email must be valid'
      ],
      passwordRules: [v => !!v || 'Password is required'],
      otpRules: [v => !!v || 'OTP is required']
    }
  },

  mounted () {
    if (this.appReady) {
      this.init()
    } else {
      Bus.$on('appReady', this.init)
    }
  },

  methods: {
    async init () {
      if (!this.credentials.email) {
        if (this.myProfile.email) {
          this.credentials.email = this.myProfile.email
          this.focusRef('password')
        } else {
          this.focusRef('email')
        }
      }
    },

    hasAccountPermission (permission) {
      if (!this.myProfile || !this.myProfile.accounts) {
        return false
      }
      return this.myProfile.accounts.some(account => {
        return account.user_permissions && account.user_permissions[permission]
      })
    },

    redirect () {
      if (this.$route.query.hasOwnProperty('redirect')) {
        this.$router.push(this.$route.query.redirect)
      } else if (this.domain === 'okdmv' || this.domain === 'atmone') {
        this.$router.push('/transactions')
      } else if (this.hasPermission('can_use_virtual_terminal') && this.terminalsCard.length > 0) {
        this.$router.push('/credit')
      } else if (this.hasPermission('can_use_virtual_terminal') && this.terminalsACH.length > 0) {
        this.$router.push('/ach')
      } else if (this.hasPermission('can_view_transactions') && this.terminalsCard.length > 0) {
        this.$router.push('/transactions')
      } else if (this.hasPermission('can_view_transactions') && this.terminalsACH.length > 0) {
        this.$router.push('/ach_transactions')
      } else if (this.hasPermission('can_view_schedules')) {
        this.$router.push('/schedules')
      } else if (this.hasAccountPermission('can_view_funding')) {
        this.$router.push('/paynetworx/funding')
      } else {
        throw new Error('No suitable permissions found')
      }
    },

    async login () {
      try {
        this.loading = true
        this.$store.commit('clearErrors')
        this.$store.commit('clearSuccesses')

        const result = await this.api({
          method: 'post',
          url: `/users/login`,
          data: this.credentials,
          auth: false
        })

        this.$store.commit('session', result.data)
        this.credentials.password = ''
        this.startIdleWatcher()
        this.checkForcePasswordWarning(result)
        this.checkForcePasswordChange(result)
      } catch (err) {
        console.log('Login error:', err)
        const errorMsg = err.response && err.response.data && err.response.data.error
        if (errorMsg) {
          this.$store.commit('error', {'login-error': errorMsg})
        }
        this.stopIdleWatcher()
        this.forceLogout()
      } finally {
        this.loading = false
      }
    },

    checkForcePasswordWarning (result) {
      const passwordAge = result.data.password_age
      const timeUntilForcePasswordChange = Math.abs(parseInt(result.data.time_until_force_password_change))
      const forcePasswordWarning = result.data.force_password_change_warning

      if (forcePasswordWarning) {
        this.$store.commit('persistentMessages', {'password-age-warining': `Your password is ${passwordAge} days old, You have ${timeUntilForcePasswordChange} days until you will be forced to change your password.`})
      }
    },

    checkForcePasswordChange (result) {
      const forcePasswordChange = result.data.force_change_password

      if (forcePasswordChange) {
        const passwordGracePeriod = Object.keys(result.data).includes('password_grace_period')
        let passwordGracePeriodDate

        if (passwordGracePeriod) {
          passwordGracePeriodDate = result.data.password_grace_period
        }

        if (forcePasswordChange && !passwordGracePeriodDate) {
          this.$store.commit('error', {'password-reset-error': 'Our security policies require that passwords be changed at regular intervals.'})
        }

        if (forcePasswordChange && passwordGracePeriodDate) {
          this.$store.commit('persistentMessages', {'password-grace-period': `You are currently on a temporary password grace period until ${this.date(passwordGracePeriodDate)}.  After this time you will be required to reset your password.`})
        }
        this.redirect()
      } else {
        this.redirect()
      }
    },

    setForgotPassword () {
      this.step = 2
    },

    async forgotPassword () {
      try {
        this.loading = true
        this.$store.commit('clearErrors')
        this.$store.commit('clearSuccesses')

        await this.api({
          method: 'put',
          url: `/users/password_reset`,
          data: this.credentials,
          auth: false
        })

        this.step = 3
        this.message = 'Please check your email'
      } catch (error) {
        this.$store.commit('error', {'recovery-email-error': 'There was an issue sending the recovery email.'})
      } finally {
        this.loading = false
      }
    },
    setNewPassword () {
      this.step = 1
      this.message = 'Please check your email'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue